export enum SwapManagementAction {
    Select = 0,
    Unbridge = 1,
    Bridge = 2,
    NewChainAsVoucher = 3,
    ResetCluster = 4,
    RemoveRecipient = 5,
    RemovePair = 7,
    ReplacePair = 8,
    ReplaceRecipient = 9,
    AddRecipient = 10
}